import React, {useEffect, useState} from 'react'
import {getPeopleCourse} from "../../../../redux/actions";
import {useParams} from "react-router";
import {Button, Container, Grid, Image, Menu} from "semantic-ui-react";
import ReactJWPlayer from 'react-jw-player';
import Help from "./Help";

const token = sessionStorage.getItem('Token')

const VideoPlayer = ({item, jwp_script}) => {
    const video = item.video.media.key+ '.html'; // + '.' + item.video.extension;
    const base = 'https://cdn.jwplayer.com/players/'; //'https://cdn.jwplayer.com/videos/';
    const file = base + video;

    return (
        <div style={{position:"relative", overflow:"hidden", paddingBottom:"56.25%"}}>
            <iframe
                src={file}
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="auto"
                style={{position:"absolute"}}
                allowFullScreen
            ></iframe>
        </div>
    );

    // return (<ReactJWPlayer
    //     playerId='my-unique-id'
    //     playerScript={jwp_script}
    //     file={file}
    // />);
}

const Active = ({active, jwp_script}) => {
    return (
        <div>
            <h2 style={{color: 'var(--red)'}}>{active.title}</h2>
            <div dangerouslySetInnerHTML={{__html: active.article}}/>
            {(active.video && active.video.media) && <p><br /><VideoPlayer item={active} jwp_script={jwp_script}/></p>}
        </div>
    );
}

export const Learn = () => {
    const params = useParams();
    const [active, setActive] = useState({});
    const [item, setItem] = useState({});
    const [help, setHelp] = useState(false);

    const course = item.course || {};
    const sections = course.course_sections || [];
    const jwp_script = course.place && course.place.jwp_script;

    const cover = course.cover ? course.path + course.cover : false;

    useEffect(() => {
        async function getData() {
            try {
                const res = await getPeopleCourse(params);
                setItem(res.data);
            } catch (e) {
                console.log(' error ddasd ', e);
            }
        }

        getData();
    }, [params])

    useEffect(() => {
        if (sections.length > 0) {
            setActive(sections[0]['children'][0]);
            // console.log(sections);
        }
    }, [sections])

    return (
        <React.Fragment>
            <div className={'learn-title'}>
                <Container>
                    <h3>
                        <Image src={cover} height={40}/>
                        {course.name}
                    </h3>
                </Container>
            </div>
            <Container>
                <Help
                    help={help}
                    setHelp={setHelp}
                    course_id={course.id}
                    place_id={course.place_id}
                />
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={4} style={{marginLeft: 0, paddingLeft: 0, paddingRight: 0}}>
                            {/*<Menu fluid vertical>*/}
                            {/*    <Menu.Item*/}
                            {/*        name='Sumário'*/}
                            {/*        active={active === 'main'}*/}
                            {/*        // onClick={this.handleItemClick}*/}
                            {/*    />*/}
                            {/*    <Menu.Item*/}
                            {/*        name='Assistir aulas'*/}
                            {/*        // active={activeItem === 'pics'}*/}
                            {/*        // onClick={this.handleItemClick}*/}
                            {/*    />*/}
                            {/*    <Menu.Item*/}
                            {/*        name='Autor do curso'*/}
                            {/*        // active={activeItem === 'companies'}*/}
                            {/*        // onClick={this.handleItemClick}*/}
                            {/*    />*/}
                            {/*    <Menu.Item*/}
                            {/*        name='Certificado'*/}
                            {/*        // active={activeItem === 'links'}*/}
                            {/*        // onClick={this.handleItemClick}*/}
                            {/*    />*/}
                            {/*</Menu>*/}
                            <Menu vertical fluid>
                                {
                                    sections.map((section) => {
                                        return (
                                            <Menu.Item>
                                                <Menu.Header>{section.title}</Menu.Header>
                                                <Menu.Menu>
                                                    {
                                                        section.children.map((child) => {
                                                            return <Menu.Item
                                                                active={active.id === child.id}
                                                                content={child.title}
                                                                onClick={() => setActive(child)}
                                                            />;
                                                        })
                                                    }
                                                </Menu.Menu>
                                            </Menu.Item>
                                        );
                                    })
                                }
                            </Menu>
                            {
                                item.id && <div style={{textAlign: "center", padding: "0 2rem"}}>
                                    <Button
                                        fluid
                                        primary
                                        content={'Emitir Certificado'}
                                        onClick={() => {
                                            window.open(`https://br.inbh.com.br/v1/people-courses/certified/${item.id}/${item.uuid}/generate.pdf`);
                                        }}
                                    />
                                    <br/>
                                    <Button
                                        fluid
                                        positive
                                        content={'Precisando de Ajuda?'}
                                        onClick={() => {
                                            setHelp(true);
                                        }}
                                    />
                                </div>
                            }
                        </Grid.Column>
                        <Grid.Column width={12}>
                            {
                                active.id ? <Active active={active} jwp_script={jwp_script}/> : 'Clique em uma aula'
                            }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </React.Fragment>
    )
}